const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop : "8px",
  },
  margin: {
    margin: theme.spacing.unit,
  },
  regions: {
    width: "100%",
    padding: "30px"
  },
  closeButton: {
    float: "right",
    cursor: "pointer",
  },
  selectRegion: {
    // height: "50px",
    display: 'flex',
    justifyContent: 'space-between',
    gap: '10px',
    fontSize: "25px",
    fontWeight: "bold"
  },
  regionTypes: {
    display: "flex",
    textAlign: "left",
    fontSize: "14px"
  },
  regionListUnderLine: {
    textDecoration: "none",
    color: "#003764!important",
    marginRight: "50px",
    
    fontSize: "16px",
    cursor: "pointer",
    fontWeight: "700",
    "@media(min-width: 960px)": {
      borderBottom: "#d7eceb 3px solid",
      paddingBottom: "17px",
    },
  },
  regionList: {
    textDecoration: "none",
    color: "#003764!important",
    marginRight: "50px",
    paddingBottom: "17px",
    fontSize: "16px",
    cursor: "pointer",
    "@media(max-width: 960px)": {
      fontWeight: "500",
    }
  },
  divder: {
    marginTop: 0,
    marginBottom: "20px",
    border: 0,
    borderTop: "1px solid #eee"
  },
  regionCountries: {
    "@media(min-width: 960px)": {
      marginTop: "40px",
    }
  },
  countryBox: {
    width: "300px",
    display: "flex",
    padding: "10px"
  },
  regionLang: {
    listStyle: "none",
    display: "flex"
  },
  countryLang: {
    width:"150px",
    display:"flex",
    flexWrap: "wrap",
  },
  flagBox: {
    paddingTop: "10px",
    paddingRight: "15px"
  },
  langDivider: {
    paddingRight:"5px",
    borderLeft: "2px solid"
  },
  lang: {
    cursor:"pointer",
    fontSize: "14px",
    paddingRight:"5px",
    '&:hover': {
      textDecoration : "underline"
    },
  },
  countryName: {
    cursor:"pointer",
    '&:hover': {
      textDecoration : "underline"
    },
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/StartContainer/CountrySelect/countrySelect.style.js